import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IKnovioPreviewLinkDAO, IKnovioConnectionPreviewLinkDTO, IKnovioPreviewLinkResponse, IKnovioArtifactPreviewLinkDTO } from '../knovio-preview-link.dao';
import * as CONNECTIONS_API from '../../constants/api/connections-api.constants';
import { IApiDateConverter } from '../../infrastructure/api-date-converter';

export class KnovioPreviewLinkDAO extends IKnovioPreviewLinkDAO {
    public async generateKnovioConnectionPreviewLink(params: IKnovioConnectionPreviewLinkDTO, signal?: AbortSignal): Promise<IKnovioPreviewLinkResponse> {
        const response = await this.apiClient.get<IKnovioPreviewLinkResponse>(CONNECTIONS_API.GET_KNOVIO_CONNECTION_PREVIEW,{
            ...params,
            expirationDate: this.apiDateConverter.dateToAPIString(params.expirationDate)
        },
        {
            signal: signal
        });
        return response.parsedResponse;
    }

    public async generateKnovioArtifactPreviewLink(params: IKnovioArtifactPreviewLinkDTO, signal?: AbortSignal): Promise<IKnovioPreviewLinkResponse> {
        const response = await this.apiClient.get<IKnovioPreviewLinkResponse>(CONNECTIONS_API.GET_KNOVIO_ARTIFACT_PREVIEW,{
            ...params,
            expirationDate: this.apiDateConverter.dateToAPIString(params.expirationDate)
        },
        {
            signal: signal
        });
        return response.parsedResponse;
    }

    constructor(
        @IoC.Inject private readonly apiClient: IApiClient,
        @IoC.Inject private readonly apiDateConverter: IApiDateConverter
    ) {
        super();
    }
}
